import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import FieldDTO from '../../components/fields/Abstract/FieldDTO';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../components/base/BootstrapComponents/BootstrapComponents';
import FileInput from '../../components/fields/FileInput/FileInput';
import CustomSelectInput from '../../components/fields/SelectInput/CustomSelectInput';

export default function RegistryImport({
  onClose, handleImport, showSelector = false, title = 'Импорт реестра',
}) {
  const [file, setFile] = useState(null);
  const { control } = useForm({ defaultValues: {} });
  const [isWithRelation, setIsWithRelation] = useState(0);

  return (
    <Dialog
      className="registry-popup-import"
      onClose={onClose}
      size="xl"
      open
    >
      <DialogTitle
        className="hff-title"
        title={(
          <>
            <div className="hff-title-text f2">{title}</div>
            <div className="hff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={onClose} />
            </div>
          </>
        )}
      />
      <DialogContent className="hff-content">
        {showSelector ? (
          <>
            <div className="f4">Выбор типа связей</div>
            <FieldDTO
              control={control}
              component={CustomSelectInput}
              dtoObject={{
                name: 'import',
                labelKey: 'import.register.select',
              }}
              withLabel
              variant="material"
              options={[
                { value: 0, name: 'Импорт реестра Перевозчиков' },
                { value: 1, name: 'Импорт связей Перевозчик-ЛТ' },
              ]}
              inputProps={{
                value: isWithRelation,
                onChange: e => {
                  setIsWithRelation(e.target.value);
                },
              }}
            />
          </>
        ) : null}
        <div className="f4">Выберите документ для импорта</div>
        <div className="registry-popup-box-control">
          <FieldDTO
            control={control}
            type="text"
            component={FileInput}
            dtoObject={{
              name: 'file',
            }}
            variant="material"
            label="Выберите фаил для импорта"
            inputProps={{
              onChange: setFile,
            }}
          />
        </div>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <Button variant="secondary" onClick={onClose}>Отменить</Button>
        <Button onClick={() => {
          onClose();
          handleImport(file, isWithRelation);
        }}
        >Импортировать
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
